export default (location, query) => ({
  methods: {
    async showPreview() {
      await this.$router.push(location);
      query && this.$scrollTo(query, 500, { offset: -100 });
    }
  }
});
